import { render, staticRenderFns } from "./templateDetails.vue?vue&type=template&id=0bbde002&scoped=true&"
import script from "./templateDetails.vue?vue&type=script&lang=js&"
export * from "./templateDetails.vue?vue&type=script&lang=js&"
import style0 from "./templateDetails.vue?vue&type=style&index=0&id=0bbde002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbde002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbde002')) {
      api.createRecord('0bbde002', component.options)
    } else {
      api.reload('0bbde002', component.options)
    }
    module.hot.accept("./templateDetails.vue?vue&type=template&id=0bbde002&scoped=true&", function () {
      api.rerender('0bbde002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/components/templateDetails.vue"
export default component.exports